var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "NsCarousel",
        {
          style: _vm.carouselStyle,
          attrs: {
            min: 3,
            max: 5,
            spacing: 10,
            "vertical-overflow-amount": 200,
            "unique-reset-key": _vm.localSkus.length,
            "hide-controls": !_vm.showControls,
            wrap: ""
          }
        },
        [
          _vm._l(_vm.localSkus, function(sku) {
            return _c(
              "div",
              { key: sku, class: _vm.$style.productCard },
              [
                _c("NsProductCard", {
                  attrs: {
                    sku: sku,
                    forcesv: _vm.forcesv,
                    "hide-exclusive-icon": _vm.hideExclusiveIcon,
                    "hide-exclusive-text-on-mobile":
                      _vm.hideExclusiveTextOnMobile,
                    "hide-favorites": _vm.hideFavorites,
                    "hide-sku": _vm.hideSku,
                    "no-action": _vm.noAction
                  }
                })
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.phabletAndDown
            ? _vm._l(2, function(num) {
                return _c("div", { key: num, class: _vm.$style.productCard })
              })
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }